import axios from 'axios';

class jrpc20WSClient {

    // Client RPC2.0 curl

    constructor(url, ba_user, ba_pwd) {
        this.url = url;
        this.ba_user = ba_user;
        this.ba_pwd = ba_pwd;
        this.charset = "UTF-8";

        console.log("JSON-RPC 2.0 Init with config: ");
        console.log({ "url": this.url, "charset": this.charset, "ba_user": this.ba_user, "ba_pwd": this.ba_pwd })
    }

    request(http_method, method, parameters, options) {
        console.log('JSON-RPC 2.0 Request');

        // preparing jsonrpc 2.0 body
        const post_data = this.prepareData(method, parameters);

        // preparing header
        const header = this.header(post_data);

        // executing request
        return this.executeRequest(http_method, header, post_data, options);

    }

    validateResponse(response) {
        // response must be defined as JSON-RPC 2.0
        if (response.jsonrpc === undefined || response.jsonrpc !== '2.0') {
            throw Error("Response not valid");
        }

        // sent and received id must be the same
        if (response.id === undefined || parseInt(response.id) !== this.call_id) {
            throw Error("Response not valid");
        }

        // result and error parameter there must not be in the same time
        if (response.result !== undefined && response.error !== undefined) {
            throw Error("Response not valid");
        }

        if (response.error !== undefined) {
            this.last_response = response.error;
            throw Error(response.error.message + " - CODE: " + response.error.code);
        }

        if (response.result === undefined) {
            console.log("JSON-RPC 2.0 - request error: Result parameter not found");
            throw Error("Response not valid");
        }

        return response.result;
    }

    executeRequest(http_method, header, post_data, options) {

        let config = {
            method: http_method,
            maxBodyLength: Infinity,
            url: this.url,
            headers: header,
            data: post_data,
            responseType: (options !== undefined && options.responseType !== undefined) ? options.responseType : 'json',
            onUploadProgress: function ({ loaded, total, progress, bytes, estimated, rate, upload = true }) {
                if (options !== undefined && options.onUploadProgress !== undefined) {
                    options.onUploadProgress(loaded, total, progress, bytes, estimated, rate, upload);
                }
            },
            onDownloadProgress: function ({ loaded, total, progress, bytes, estimated, rate, download = true }) {
                if (options !== undefined && options.onDownloadProgress !== undefined) {
                    options.onDownloadProgress(loaded, total, progress, bytes, estimated, rate, download);
                }
            }
        };

        return new Promise((resolve, reject) => {
            axios.request(config).then((response) => {
                console.log(response.data);
                try {
                    let validation = true;
                    if (options !== undefined && options.responseValidation !== undefined) {
                        validation = options.responseValidation;
                    }

                    if(validation) {
                        const validated_response = this.validateResponse(response.data);
                        resolve(validated_response);
                    } else {
                        resolve(response);
                    }
                } catch (error) {
                    reject(error);
                }
            }).catch((error) => {
                console.log(error);
                reject(error);
            });
        });
    }

    header(post_data) {
        const token = btoa(this.ba_user + ':' + this.ba_pwd);
        const header = {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ' + token,
            // 'charset': this.charset,
            'Accept': 'application/json',
            // 'Content-Length': post_data.length
        }

        return header
    }

    prepareData(method, data) {
        this.call_id = Math.floor(Math.random() * (1000 - 1) + 1);

        const json_data = {
            'jsonrpc': '2.0',
            'method': method,
            'params': data,
            'id': this.call_id
        }

        console.log('JSON-RPC 2.0 - Request Body: ');
        console.log(json_data);

        return JSON.stringify(json_data);
    }
}

export default jrpc20WSClient;